<template lang="pug">
.v-field-range.field-range(:class="{'field-range--sm': field.size === 'sm'}")
	label.filter__group-title.flc(v-if="field.label")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	.field-range__cells
		.field-range__prefix(v-if="field.prefixMin") {{field.prefixMin}}
		.field-range__cell
			v-field.field-range__input(
				:field="{type: 'number', inputmode: 'numeric', disabled: field.disabled, placeholder: field.placeholderMin}"
				v-model="textLocalValueMin"
				@blur="blurHandlerMin"
				@update:model-value="checkDoubleValueMin"
				@keyup.native.enter="emitInput")
			.field-range__postfix(v-if="field.postfixMin") {{field.postfixMin}}
		.field-range__spacer —
		.field-range__prefix(v-if="field.prefixMax") {{field.prefixMax}}
		.field-range__cell
			v-field.field-range__input(
				:field="{type: 'number', inputmode: 'numeric', disabled: field.disabled,  placeholder: field.placeholderMax}"
				v-model="textLocalValueMax"
				@blur="blurHandlerMax"
				@update:model-value="checkDoubleValueMax"
				@keyup.native.enter="emitInput")
		.field-range-slider__input-wraps
			.field-range-slider__visual-handles
				.field-range-slider__visual-handle(v-if="!field.singleHandle" :style="{'left': handleMinLeft + '%'}")
				.field-range-slider__visual-handle(:style="{'left': handleMaxLeft + '%'}")
			.field-range-slider__input-wrap.field-range-slider__input-wrap--left(v-if="!field.singleHandle")
				input.field-range-slider__input.field-range-slider__input--left(ref="leftInput"
					:disabled="field.disabled"
					type="range"
					:min="field.min"
					:max="field.max"
					:step="field.precision || 1"
					v-model="localValueMin"
					@input="handleInputSliderMin"
					@mouseup="inputMouseup"
					@touchend.prevent="inputMouseup")
			.field-range-slider__slider-track(:style="{'left': (handleMinLeft + '%') || 0, 'right': 100 - handleMaxLeft + '%'}")
			.field-range-slider__input-wrap.field-range-slider__input-wrap--right
				input.field-range-slider__input.field-range-slider__input--right(ref="rightInput"
					:disabled="field.disabled"
					type="range"
					:min="field.min"
					:max="field.max"
					:step="field.precision || 1"
					v-model="localValueMax"
					@input="handleInputSliderMax"
					@mouseup="inputMouseup"
					@touchend.prevent="inputMouseup")
		.field-range-slider__unit(v-if="field.unit && !field.postfixMax") {{field.unit}}
		.field-range__postfix(v-if="field.postfixMax") {{field.postfixMax}}
</template>

<script>
import formattingMixin from '../components/mixins/v-mixin-formatting.vue';

export default {
	mixins: [
		formattingMixin
	],
	props: {
		field: {
			type: Object,
			default: null,
			required: true
		},

		modelValue: {
			type: Object,
			default: null
		}
	},

	emits: [
		'update:model-value'
	],

	data() {
		return {
			localValue: null,
			rulerWidth: 0,
			inputValue: null,
			localValueMin: null,
			localValueMax: null,
			minGap: 1,
			inputValueMax: null,
			minInputWidth: 0,
			checkDoubleValueMinTimoutID: null,
			checkDoubleValueMaxTimoutID: null,
			textLocalValueMin: null,
			textLocalValueMax: null,
			loading: false
		};
	},

	computed: {
		handleMinLeft() {
			return ((this.localValueMin - this.field.min) / (this.field.max - this.field.min)) * 100;
		},
		handleMaxLeft() {
			return ((this.localValueMax - this.field.min) / (this.field.max - this.field.min)) * 100;
		}
	},

	mounted() {
		this.updateLocalValue()
	},

	methods: {
		emitInput() {
			clearTimeout(this.debounceTimeout);

			if (this.field) {
				if (typeof this.field.max == 'number' && this.field.max !== Infinity) {
					this.localValue.max = Math.min(this.localValue.max, this.field.max);
				}
				if (typeof this.field.min == 'number' && this.field.max !== -Infinity) {
					this.localValue.min = Math.min(this.localValue.min, this.field.min);
				}

				if (this.localValue.min > this.localValue.max) {
					this.localValue.max = this.localValue.min;
				}
			}

			this.$emit('update:model-value', this.localValue);
		},

		setMinInputWidth() {
			this.$nextTick(() => {
				this.minInputWidth = this.innerWidth(this.$refs['leftInput']) + 'px';
			});
		},

		innerWidth(el, value) {
			if (value === undefined) {
				return el.clientWidth;
			} else {
				el.style.width = value;
			}
		},

		blurHandlerMin() {
			this.setMinInputWidth();
			this.textLocalValueMin = this.textLocalValueMin - (this.textLocalValueMin % this.minGap);
			if (this.textLocalValueMin === this.textLocalValueMax) {
				this.textLocalValueMin = this.textLocalValueMin - this.minGap;
			}
			if (this.textLocalValueMin > this.textLocalValueMax) {
				this.localValueMin = this.textLocalValueMin = this.localValueMax - this.minGap;
			} else if (this.textLocalValueMin < this.field.min) {
				this.localValueMin = this.textLocalValueMin = this.field.min;
			} else {
				this.localValueMin = this.textLocalValueMin;
			}
			this.setMinInputWidth();
			this.inputMouseup();
		},

		blurHandlerMax() {
			this.textLocalValueMax = this.textLocalValueMax - (this.textLocalValueMax % this.minGap);
			if (this.textLocalValueMin === this.textLocalValueMax) {
				this.textLocalValueMax = this.textLocalValueMin + this.minGap;
			}
			if (this.textLocalValueMax > 0 && (this.textLocalValueMax > this.field.max)) {
				this.localValueMax = this.textLocalValueMax = this.field.max;
			} else if (this.textLocalValueMax < this.textLocalValueMin + this.minGap) {
				this.localValueMax = this.textLocalValueMax = +this.localValueMin + this.minGap;
			} else {
				this.localValueMax = this.textLocalValueMax;
			}
			this.inputMouseup();
		},

		checkDoubleValueMin() {
			clearTimeout(this.checkDoubleValueMinTimoutID);
			this.setMinInputWidth();
			this.checkDoubleValueMinTimoutID = setTimeout(() => {
				this.textLocalValueMin = this.textLocalValueMin - (this.textLocalValueMin % this.minGap);
				if (this.textLocalValueMin > this.textLocalValueMax) {
					this.localValueMin = this.textLocalValueMin = this.localValueMax - this.minGap;
				} else if (this.textLocalValueMin < this.field.min) {
					this.localValueMin = this.textLocalValueMin = this.field.min;
				} else {
					this.localValueMin = this.textLocalValueMin;
				}
				this.setMinInputWidth();
				this.inputMouseup();
			}, 1500);
		},

		checkDoubleValueMax() {
			clearTimeout(this.checkDoubleValueMaxTimoutID);
			this.checkDoubleValueMaxTimoutID = setTimeout(() => {
				this.textLocalValueMax = this.textLocalValueMax - (this.textLocalValueMax % this.minGap);
				if (this.textLocalValueMax > 0 && (this.textLocalValueMax > this.field.max)) {
					this.localValueMax = this.textLocalValueMax = this.field.max;
				} else if (this.textLocalValueMax < this.textLocalValueMin + this.minGap) {
					this.localValueMax = this.textLocalValueMax = +this.localValueMin + this.minGap;
				} else {
					this.localValueMax = this.textLocalValueMax;
				}
				this.inputMouseup();
			}, 1500);
		},

		checkValueMax() {
			clearTimeout(this.checkDoubleValueMaxTimoutID);
			this.checkDoubleValueMaxTimoutID = setTimeout(() => {
				this.textLocalValueMax = this.textLocalValueMax - (this.textLocalValueMax % this.minGap);
				if (this.textLocalValueMax < this.field.min) {
					this.localValueMax = this.textLocalValueMax = this.field.min;
				} else if (this.textLocalValueMax > 0 && (this.textLocalValueMax > this.field.max)) {
					this.localValueMax = this.textLocalValueMax = this.field.max;
				} else {
					this.localValueMax = this.textLocalValueMax;
				}
				// this.inputMouseup();
			}, 1500);
		},

		blurCheckValueMax() {
			clearTimeout(this.checkDoubleValueMaxTimoutID);
			this.textLocalValueMax = this.textLocalValueMax - (this.textLocalValueMax % this.minGap);
			if (this.textLocalValueMax < this.field.min) {
				this.localValueMax = this.textLocalValueMax = this.field.min;
			} else if (this.textLocalValueMax > 0 && (this.textLocalValueMax > this.field.max)) {
				this.localValueMax = this.textLocalValueMax = this.field.max;
			} else {
				this.localValueMax = this.textLocalValueMax;
			}
			this.inputMouseup();
		},

		handleInputSliderMin() {
			if (parseInt(this.localValueMax) - parseInt(this.localValueMin) <= this.minGap) {
				this.localValueMin = parseInt(this.localValueMax) - this.minGap;
			} else {
				this.setMinInputWidth();
			}
			this.textLocalValueMin = String(this.localValueMin);
			this.emitUpdate();
		},
		handleInputSliderMax() {
			if (!this.field.singleHandle) {
				if (parseInt(this.localValueMax) - parseInt(this.localValueMin) <= this.minGap) {
					this.localValueMax = parseInt(this.localValueMin) + this.minGap;
				}
			}
			this.textLocalValueMax = String(this.localValueMax);
			this.emitUpdate();
		},

		updateLocalValue() {
			this.localValue = this.field.value;
			this.localValueMin = this.localValue.min || this.field.min;
			this.localValueMax = this.localValue.max || this.field.max;
			setTimeout(() => {
				this.$nextTick(() => {
						this.textLocalValueMin = this.localValueMin;
						this.textLocalValueMax = this.localValueMax;
						this.setMinInputWidth();
				});
			}, 300);
		},

		inputMouseup() {
			this.$emit('update:model-value', {
				min: this.localValueMin,
				max: this.localValueMax
			});
		},

		emitUpdate() {
			this.$emit('update:model-value', { min: this.localValueMin, max: this.localValueMax });
		}
	}
};
</script>
